"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getOverflowOptions = void 0;
var tslib_1 = require("tslib");
var placements_1 = require("../_components/_tooltip/placements");
var autoAdjustOverflowEnabled = {
    adjustX: 1,
    adjustY: 1,
};
var autoAdjustOverflowDisabled = {
    adjustX: 0,
    adjustY: 0,
};
var targetOffset = [0, 0];
function getOverflowOptions(autoAdjustOverflow) {
    if (typeof autoAdjustOverflow === 'boolean') {
        return autoAdjustOverflow ? autoAdjustOverflowEnabled : autoAdjustOverflowDisabled;
    }
    return tslib_1.__assign(tslib_1.__assign({}, autoAdjustOverflowDisabled), autoAdjustOverflow);
}
exports.getOverflowOptions = getOverflowOptions;
function getPlacements(config) {
    var _a = config.arrowWidth, arrowWidth = _a === void 0 ? 5 : _a, _b = config.horizontalArrowShift, horizontalArrowShift = _b === void 0 ? 16 : _b, _c = config.verticalArrowShift, verticalArrowShift = _c === void 0 ? 8 : _c, autoAdjustOverflow = config.autoAdjustOverflow;
    var placementMap = {
        left: {
            points: ['cr', 'cl'],
            offset: [-4, 0],
        },
        right: {
            points: ['cl', 'cr'],
            offset: [4, 0],
        },
        top: {
            points: ['bc', 'tc'],
            offset: [0, -4],
        },
        bottom: {
            points: ['tc', 'bc'],
            offset: [0, 4],
        },
        topLeft: {
            points: ['bl', 'tc'],
            offset: [-(horizontalArrowShift + arrowWidth), -4],
        },
        leftTop: {
            points: ['tr', 'cl'],
            offset: [-4, -(verticalArrowShift + arrowWidth)],
        },
        topRight: {
            points: ['br', 'tc'],
            offset: [horizontalArrowShift + arrowWidth, -4],
        },
        rightTop: {
            points: ['tl', 'cr'],
            offset: [4, -(verticalArrowShift + arrowWidth)],
        },
        bottomRight: {
            points: ['tr', 'bc'],
            offset: [horizontalArrowShift + arrowWidth, 4],
        },
        rightBottom: {
            points: ['bl', 'cr'],
            offset: [4, verticalArrowShift + arrowWidth],
        },
        bottomLeft: {
            points: ['tl', 'bc'],
            offset: [-(horizontalArrowShift + arrowWidth), 4],
        },
        leftBottom: {
            points: ['br', 'cl'],
            offset: [-4, verticalArrowShift + arrowWidth],
        },
    };
    Object.keys(placementMap).forEach(function (key) {
        placementMap[key] = config.arrowPointAtCenter
            ? tslib_1.__assign(tslib_1.__assign({}, placementMap[key]), { overflow: getOverflowOptions(autoAdjustOverflow), targetOffset: targetOffset }) : tslib_1.__assign(tslib_1.__assign({}, placements_1.placements[key]), { overflow: getOverflowOptions(autoAdjustOverflow) });
        placementMap[key].ignoreShake = true;
    });
    return placementMap;
}
exports.default = getPlacements;
//# sourceMappingURL=placements.js.map